import { AlertTriangle, Ban } from 'lucide-react';
import { Badge } from '@ncoder/ui';

type UsageHealthStatus = 'over_budget' | 'blocked';

interface UsageStatusConfig {
  label: string;
  icon: typeof AlertTriangle;
  className: string;
}

const USAGE_STATUS_CONFIG: Record<UsageHealthStatus, UsageStatusConfig> = {
  over_budget: {
    label: 'Over budget',
    icon: AlertTriangle,
    className: 'border-warning/30 bg-warning/10 text-warning',
  },
  blocked: {
    label: 'Blocked',
    icon: Ban,
    className: 'border-destructive/30 bg-destructive/10 text-destructive',
  },
};

// Blocked (LiteLLM has cut the seat off) takes precedence over merely over-budget.
export function UsageStatusBadge({ blocked, overBudget }: { blocked: boolean; overBudget: boolean }) {
  if (!blocked && !overBudget) return null;
  const cfg = USAGE_STATUS_CONFIG[blocked ? 'blocked' : 'over_budget'];

  return (
    <Badge variant="outline" className={`gap-1 ${cfg.className}`}>
      <cfg.icon className="h-3 w-3" />
      {cfg.label}
    </Badge>
  );
}
